import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.dark.css';
import store from './store/store';
import DatetimePicker from 'vuetify-datetime-picker';
import vueDebounce from 'vue-debounce';
// import the library
import VStripeElements from 'v-stripe-elements/lib'
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)
// and register it
Vue.use(VStripeElements);
Vue.use(require('vue-moment'));
Vue.use(DatetimePicker);
Vue.use(vueDebounce);
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');
